import { render, staticRenderFns } from "./LinkFundFormat.vue?vue&type=template&id=b54239cc&"
import script from "./LinkFundFormat.vue?vue&type=script&lang=ts&"
export * from "./LinkFundFormat.vue?vue&type=script&lang=ts&"
import style0 from "./LinkFundFormat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports